import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[tooltipIfOverflow]'
})
export class TooltipIfOverflowDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input('tooltipIfOverflow') tooltipText = '';

  private resizeObserver?: ResizeObserver;

  constructor(private el: ElementRef<HTMLElement>, private tooltip: MatTooltip) {}

  ngAfterViewInit(): void {
    // Prima valutazione dopo il render
    queueMicrotask(() => this.updateTooltip());

    // Osserva variazioni di dimensione del container
    this.resizeObserver = new ResizeObserver(() => {
      this.updateTooltip();
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tooltipText']) {
      queueMicrotask(() => this.updateTooltip());
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private updateTooltip(): void {
    const element = this.el.nativeElement;

    const isOverflowing = element.scrollWidth > element.clientWidth;

    this.tooltip.message = this.tooltipText;
    this.tooltip.disabled = !isOverflowing;
  }
}
